import { Action,action } from 'easy-peasy';

export interface TablePSIZNLMap {
  codePSIZNL: string;
  idVisioglobe: string;
}

export interface TablePSIZNLModel {
  psiznlTableMap: TablePSIZNLMap[];
  setPsiznlTableMap: Action<TablePSIZNLModel, TablePSIZNLMap[]>;
}

const tablePSIZNL: TablePSIZNLModel = {
  psiznlTableMap: [],
  setPsiznlTableMap: action((state, payload) => {
    state.psiznlTableMap = payload;
  }),
};

export default tablePSIZNL;
